import PropTypes from 'prop-types'

export const OverallCalculationStrategy = {
  automatic: 'automatic',
  hybrid: 'hybrid',
  custom: 'custom',
}
export const overallCalculationStrategyOptionPropTypes = PropTypes.oneOf(
  Object.values(OverallCalculationStrategy)
)

export const OverallCalculationStrategyLabels = {
  automatic: {
    abbreviated: 'Automatic',
    long: 'Fully Automatic'
  },
  hybrid: {
    abbreviated: 'Hybrid',
    long: 'Hybrid (Some Customisation)',
  },
  custom: {
    abbreviated: 'Custom',
    long: 'Fully Customised'
  }
}

/**
 * Based on asset's allow_automated_income_calculation field and it's asset
 * events allowCalculationToExceedSpecifiedValue metadata field, determine which
 * overall calculation strategy is currently active.
 *
 * @param {Object[]} assets - a list of assets, typically belonging to a scenario
 * @returns {String} - a calculation strategy enum option
 */
export const getCalculationStrategy = (assets) => {
  if (assets == []) {
    return OverallCalculationStrategy.automatic
  }

  let automationsCount = 0
  let totalCount = 0

  assets.forEach(asset => {
    totalCount += 1

    if (asset.allow_automated_income_calculation) {
      automationsCount += 1
    }

    asset.asset_events.forEach(assetEvent => {
      totalCount += 1

      const allowCalculationToExceedSpecifiedValue = assetEvent?.payload?.metadata?.allowCalculationToExceedSpecifiedValue
      if (allowCalculationToExceedSpecifiedValue) {
        automationsCount += 1
      }
    })
  })

  if (automationsCount === totalCount) {
    return OverallCalculationStrategy.automatic
  } else if (automationsCount === 0) {
    return OverallCalculationStrategy.custom
  } else {
    return OverallCalculationStrategy.hybrid
  }
}
